<template>
  <div>
    <template v-if="isEdit">
      <div class="caption">
        {{ $t('Realname') }}
      </div>

      <div class="form-control">
        <input type="text" v-model="name" />
      </div>

      <div class="caption">
        {{ $t('Address') }}
      </div>

      <div class="form-control">
        <textarea v-model="address" rows="3" style="resize: vertical"></textarea>
      </div>

      <div class="caption">
        {{ $t('Tel.') }}
      </div>

      <div class="form-control">
        <input type="tel" maxlength="10" v-model="tel" />
      </div>

      <v-btn outline small fab color="primary" @click="saveChange">
        <span class="fa fa-pencil-alt"></span>
      </v-btn>
    </template>

    <template v-else>
      <nl2br tag="span" :text="value" :title="value" style="word-wrap: break-word;" />
      <div style="display: inline-block">
        <v-btn flat fab small color="primary" class="ma-0" @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <template v-if="hasCopy">
          <v-tooltip v-model="showCopy" bottom color="success">
            <template v-slot:activator="{}">
              <v-btn
                flat
                fab
                small
                class="ma-0"
                color="primary"
                v-clipboard:copy="value"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
              >
                <v-icon>file_copy</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Copied') }}</span>
          </v-tooltip>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Nl2br from 'vue-nl2br'
export default {
  props: ['value', 'hasCopy'],
  components: {
    Nl2br
  },
  data() {
    return {
      isEdit: false,
      name: '',
      address: '',
      tel: '',
      showCopy: false
    }
  },
  mounted() {
    this.formatInfo()
  },
  methods: {
    formatInfo() {
      try {
        var info = this.value.split(' , ')
        if (info.length >= 3) {
          this.name = info[0].trim()
          this.tel = info[info.length - 1].trim()
          delete info[0]
          delete info[info.length - 1]
          this.address = info.join(' ').trim()
        }
      } catch (error) {
        this.address = this.value
      }
    },
    saveChange: function() {
      this.isEdit = false
      var info = [this.name, this.address, this.tel]
      this.$emit('input', info.join(' , '))
      this.$emit('edited')
    },
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {}
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.formatInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/EditAddress.vue